import { baseUrl_SPB } from "../BaseUrl";



const FetchAreasService = async (token) => {
//console.log('fetching areas');
  try {
    const response = await fetch(`${baseUrl_SPB}/api/v1/company/fetchcompanybyid/area`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
   
    if (!response.ok) {
      throw new Error('Failed to unavailability data');
    }
    //console.log('response', response);
    const data = await response.json();
    //console.log('data', data);
    return data;

  } catch (error) {
    console.error('Error fetching unavailability:', error);
  }
}



export default FetchAreasService;